import { apiClient } from 'lib/api';
import { useQuery } from '@tanstack/react-query';
import type { SynchronousQueryConfig } from 'lib/react-query';
import type { EmergencyError, EmergencyParams } from './types';
import type { ApiNetwork, Network } from 'types/shared';
import getApiPrefix from 'utils/getApiPrefix';

interface CheckEmergencyPromise extends EmergencyParams, EmergencyError {}

export const checkEmergency = async (apiNetwork: ApiNetwork): Promise<CheckEmergencyPromise> => {
  const res = await apiClient.get<CheckEmergencyPromise>(`${apiNetwork}/emergency`);
  return res.data;
};

interface UseToggleEmergencyOptions<TData> {
  network: Network;
  config?: SynchronousQueryConfig<typeof checkEmergency, TData>;
}

export const useCheckEmergency = <TData = CheckEmergencyPromise>({
  network,
  config,
}: UseToggleEmergencyOptions<TData>) => {
  const apiNetwork = getApiPrefix(network);
  return useQuery({
    staleTime: 60 * 30 * 1000,
    ...config,
    queryFn: () => checkEmergency(apiNetwork),
    queryKey: [apiNetwork, 'emergency'],
    refetchInterval: 60 * 1000,
  });
};
